import { Button, type ButtonProps } from '@chakra-ui/react';
import { ArrowRight } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { ONBOARDING_PALETTE } from './onboarding-palette';

/** The full-width primary button of the onboarding ("Continue" by default). */
export const OnboardingContinueButton = ({ children, ...props }: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      colorPalette="primary"
      w="full"
      h="52px"
      mt="26px"
      borderRadius="12px"
      fontFamily="heading"
      fontSize="15px"
      fontWeight="600"
      _disabled={{ bg: ONBOARDING_PALETTE.progressTrack, color: 'inkSubtle', opacity: 1 }}
      {...props}
    >
      {children ?? t('onboarding.continue')}
      <ArrowRight width={18} height={18} aria-hidden />
    </Button>
  );
};
